import React from 'react';

import List from './list/list'
import ListPagify from './list/list-pagify'
import ListFilter from './list/list-filter'
import Loading from './loading/loading'
import Empty from './empty'

class ItemList extends React.Component {

    render() {
        let { isFetching, pageName, currentPage, collection, collectionCount, collectionFilter } = this.props.conf;
        let collectionLength = collection.length;

        return (
            <div>
                <Loading printable={isFetching}/>

                <Empty printable={!isFetching && collectionLength === 0}/>

                {collectionLength > 0 && (<div>
                    <ListFilter collection={collectionFilter}/>
                    <List collection={collection} />
                    <ListPagify name={pageName} collectionCount={collectionCount} current={currentPage}/>
                </div>)}
            </div>
        );
    }
}

export default ItemList;